module.exports = __webpack_public_path__ + "static/wireframes-1-9b9487e4c818262ccaf4b056ef8e5db5.jpg";